export default __webpack_public_path__ + "img/63.2df431d.svg";